<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content batch-print-dialog__content">
  <p class="batch-print-dialog__message">{{ data.message }}</p>

  @if (data.printType === 'label') {
    <form [formGroup]="printLabelsForm" class="batch-print-dialog__form">
      <mat-form-field appearance="outline" class="batch-print-dialog__field">
        <mat-label>Client name</mat-label>
        <input required data-testid="client-name" type="text" placeholder="Client name" matInput formControlName="client" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="batch-print-dialog__field">
        <mat-label>Prescriber name</mat-label>
        <input
          required
          data-testid="prescriber-name"
          type="text"
          placeholder="Prescriber name"
          matInput
          formControlName="prescriber"
        />
      </mat-form-field>

      <mat-checkbox [checked]="largeSize" (change)="largeSize = !largeSize" color="primary">
        Large size
      </mat-checkbox>
    </form>
  }
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  @if (data.printType === 'barcode') {
    <button type="button" mat-flat-button (click)="print()" color="primary" cdkFocusInitial>Print</button>
  }
  @if (data.printType === 'label') {
    <button
      type="button"
      [disabled]="printLabelsForm.invalid"
      mat-flat-button
      (click)="print()"
      color="primary"
      cdkFocusInitial
    >
      Print
    </button>
  }
</div>
